export const configs = {
    serverUrl: process.env.REACT_APP_DEV_SERVER,
    fileServer: process.env.REACT_APP_DEV_FILE_SERVER,
    filePath: process.env.REACT_APP_DEV_FILE_PATH
}